import { render } from "./FrmExpeditionDocumentNew.vue?vue&type=template&id=7aa4bbda"
import script from "./FrmExpeditionDocumentNew.vue?vue&type=script&lang=js"
export * from "./FrmExpeditionDocumentNew.vue?vue&type=script&lang=js"

import "./FrmExpeditionDocumentNew.vue?vue&type=style&index=0&id=7aa4bbda&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__